export const ID_ICMS_IPI = 2;
export const ID_CONTRIBUICOES = 1;

export const CABECALHO_PLANILHA: string[] = ['Cnpj', 'NomeEmpresarial', 'UF', 'Matriz', 'InscricaoEstadual', 'CodigoSCP', 'Categorias', 'ExcecaoIcms',
'ObrigacaoContribuicoes', 'ObrigacaoIcms', 'NivelRiscoAceitavelContribuicoes', 'NivelRiscoAceitavelIcms', 'PararProcessoContribuicoes', 'PararProcessoIcms',
'GerarApuracaoContribuicoes', 'GerarApuracaoIcmsIpi',
'DiasNotificacaoValidacaoContribuicoes', 'DiasNotificacaoAssinaturaContribuicoes', 'DiasNotificacaoTransmissaoContribuicoes',
'DiasNotificacaoValidacaoIcmsIpi', 'DiasNotificacaoAssinaturaIcmsIpi', 'DiasNotificacaoTransmissaoIcmsIpi', 
'InicioAutomacaoContribuicoes', 'InicioAutomacaoIcms', 'UsuarioNome', 'UsuarioEmail', 'UsuarioPerfil', 'UsuarioObrigacoes',
'ContatoNomeContribuicoes', 'ContatoEmailContribuicoes', 'ContatoNomeIcms', 'ContatoEmailIcms'];

export const CABECALHO_PLANILHA_IMPORTACAO_PROCURACOES: string[] = ['NomeEmpresarial', 'NumeroRegistro', 'VigenciaInicio', 'VigenciaFim'];

export const TEXTO_TOOLTIP_SENHAS: string = `A senha irá expirar periodicamente e deverá ter no mínimo 8 caracteres, e conter pelo menos uma maiúscula, uma minúscula, um número e um caractere especial. ( [espaço] ! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \ ] ^ _ ` + "` { | } ~) e não poderá ser igual às quatro últimas utilizadas.";

export const CAMPOS_MATRIZ: Array<string> = ['Matriz', 'Filial'];

export const CAMPOS_SIM_NAO: Array<string> = ['Sim', 'Não'];

export const CAMPOS_NIVEL_RISCO_ACEITAVEL: Array<string> = ['Sem advertências', 'Com advertências'];

export const CAMPOS_OBRIGACOES: Array<string> = ['ICMS', 'Contribuições', 'Ambas'];

export const AMBIENTES: {Develop: string, Homolog: string, Production: string} = {
    Develop: 'develop',
    Homolog: 'homolog',
    Production: 'production' 
} 

export const EMPRESAS_DEMONSTRACAO: {id: number, ambiente: string}[] = 
[
    {id: 124, ambiente: AMBIENTES.Homolog}
]; 